//#region ../base/util/url.ts
function joinParts(...parts) {
	return parts.filter(Boolean).join("/").split("/").filter(Boolean).join("/");
}
function joinUrl(...parts) {
	if (parts[0]?.startsWith("http")) {
		const url = new URL(parts.join("/"));
		url.pathname = `/${joinParts(...url.pathname.split("/"))}`;
		return url.toString();
	}
	return joinParts(...parts);
}

//#endregion
export { joinUrl };
//# sourceMappingURL=url.js.map